let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page025_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page025_game0/audio/false.mp3',
    // positive: 'games/page025_game0/audio/true.mp3',
    click: 'games/page025_game0/audio/click.mp3',
    icon: {
      on: 'games/page025_game0/img/audioOn.png',
      off: 'games/page025_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 165,
    height: 305,
  },
  layoutItems: [
    {
      pos: {
        x: 1150 + 115,
        y: 132 - 65,
      },
    },
    {
      pos: {
        x: 1150 + 115,
        y: 329 - 65,
      },
    },
    {
      pos: {
        x: 1150 + 115,
        y: 526 - 65,
      },
    },
    {
      pos: {
        x: 1150 + 115,
        y: 723 - 65,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 1159 + 361 - 126,
        y: -9,
      },
    },
    {
      pos: {
        x: 1561,
        y: -9,
      },
    },
    {
      pos: {
        x: 1731,
        y: -9,
      },
    },
    //
    {
      pos: {
        x: 1159 + 361 - 126,
        y: 188,
      },
    },
    {
      pos: {
        x: 1561,
        y: 188,
      },
    },
    {
      pos: {
        x: 1731,
        y: 188,
      },
    },
    //
    {
      pos: {
        x: 1159 + 361 - 126,
        y: 386,
      },
    },
    {
      pos: {
        x: 1561,
        y: 386,
      },
    },
    {
      pos: {
        x: 1731,
        y: 386,
      },
    },
    //
    {
      pos: {
        x: 1159 + 361 - 126,
        y: 583,
      },
    },
    {
      pos: {
        x: 1561,
        y: 583,
      },
    },
    {
      pos: {
        x: 1731,
        y: 583,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: true,
  shuffleInsideItems: false,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a02',
            image: {
              src: 'games/page025_game0/img/1_doll.png',
            },
            width: 126,
            height: 219,
            incorrectItems: {
              images: [
                {
                  src: 'games/page025_game0/img/1_doll_red.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 126,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
        {
          imageSrc: 'games/page025_game0/img/doll.png',
          audioSrc: 'games/page025_game0/audio/34_two.mp3',
          correct: {
            image: {
              src: 'games/page025_game0/img/2.png',
            },
            width: 125,
            height: 219,
            correctItems: {
              images: [
                {
                  src: 'games/page025_game0/img/2_green.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 125,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page025_game0/img/3.png',
            },
            width: 125,
            height: 219,
            incorrectItems: {
              images: [
                {
                  src: 'games/page025_game0/img/3_red.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 125,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a03',
            image: {
              src: 'games/page025_game0/img/1_doll.png',
            },
            width: 126,
            height: 219,
            incorrectItems: {
              images: [
                {
                  src: 'games/page025_game0/img/1_doll_red.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 126,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
        {
          imageSrc: 'games/page025_game0/img/ball.png',
          audioSrc: 'games/page025_game0/audio/34_two.mp3',
          correct: {
            image: {
              src: 'games/page025_game0/img/2.png',
            },
            width: 125,
            height: 219,
            correctItems: {
              images: [
                {
                  src: 'games/page025_game0/img/2_green.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 125,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page025_game0/img/3.png',
            },
            width: 125,
            height: 219,
            incorrectItems: {
              images: [
                {
                  src: 'games/page025_game0/img/3_red.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 125,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a01',
            image: {
              src: 'games/page025_game0/img/1_doll.png',
            },
            width: 126,
            height: 219,
            incorrectItems: {
              images: [
                {
                  src: 'games/page025_game0/img/1_doll_red.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 126,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page025_game0/img/2.png',
            },
            width: 125,
            height: 219,
            incorrectItems: {
              images: [
                {
                  src: 'games/page025_game0/img/2_red.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 125,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
        {
          imageSrc: 'games/page025_game0/img/car.png',
          audioSrc: 'games/page025_game0/audio/35_three.mp3',
          correct: {
            image: {
              src: 'games/page025_game0/img/3.png',
            },
            width: 125,
            height: 219,
            correctItems: {
              images: [
                {
                  src: 'games/page025_game0/img/3_green.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 125,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          imageSrc: 'games/page025_game0/img/robot.png',
          audioSrc: 'games/page025_game0/audio/33_one.mp3',
          correct: {
            audioId: 'a04',
            image: {
              src: 'games/page025_game0/img/1_doll.png',
            },
            width: 126,
            height: 219,
            correctItems: {
              images: [
                {
                  src: 'games/page025_game0/img/1_doll_green.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 126,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page025_game0/img/2.png',
            },
            width: 125,
            height: 219,
            incorrectItems: {
              images: [
                {
                  src: 'games/page025_game0/img/2_red.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 125,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page025_game0/img/3.png',
            },
            width: 125,
            height: 219,
            incorrectItems: {
              images: [
                {
                  src: 'games/page025_game0/img/3_red.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 125,
                  height: 219,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page025_game0/audio/29_car.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page025_game0/img/audioOn.png', iconOff: 'games/page025_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 77,
        x: -245,
      },
      width: '42px',
      height: '42px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page025_game0/audio/30_doll.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page025_game0/img/audioOn.png', iconOff: 'games/page025_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 105,
        x: -245,
      },
      width: '42px',
      height: '42px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page025_game0/audio/31_ball.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page025_game0/img/audioOn.png', iconOff: 'games/page025_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 100,
        x: -245,
      },
      width: '42px',
      height: '42px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: 'games/page025_game0/audio/32_robot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page025_game0/img/audioOn.png', iconOff: 'games/page025_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 100,
        x: -245,
      },
      width: '42px',
      height: '42px',
      unit: 'px',
    },
  ],
};

export default elements;
